<template>
  <section class="toolbar">
    <h5>Links e Alertas</h5>
    <div class="links">
      <ul v-if="respFin">
        <li v-for="item in links" :key="item.slug" :class="item.class">
          <a href="#" @click.prevent="trackRoute(item)">
            <div>
              <fa :icon="item.icon" class="icon"/>
              <p>{{ item.label }}</p>
            </div>
          </a>
        </li>
        <li v-for="item in alertas" :key="item">
          <a href="#" @click.prevent="trackRoute(item)">
            <div>
              <fa :icon="item.icon" class="icon"/>
              <p>{{ item.label }}</p>
            </div>
            <span>
              {{ item.value }}
            </span>
            <span class="negocie" v-if="item.slug == 'pagamentos' && item.value > 0">
              Negocie Já!
            </span>
          </a>
        </li>
      </ul>
    </div>
    <div v-if="aluno">
      <historico-atendimento :id="aluno.Aluno.idAluno" :type="histType"/>
    </div>
    <modal ref="modal" wrapped>
      <div v-if="modalContent == 'shop'" class="modalWrap">
        <a href="#" class="btn btn-success btn-large" @click.prevent="trackLink('shop-fin')">Responsável financeiro</a>
        <a href="#" class="btn btn-success-2 btn-large" @click.prevent="trackLink('shop-ped')">Responsável pedagógico</a>
      </div>
      <form v-if="modalContent == 'extrato'" class="extratoForm" @submit.prevent="openExtrato">
        <template v-if="responsaveisFinanceiros.length">
          <select-control
            v-model="responsavelFinanceiroSelecionado"
            :options="responsaveisFinanceiros"
            label="Responsável financeiro"
            placeholder="Selecione o responsável financeiro"
            required
            norequiredtag
          />
          <button
            type="submit"
            class="btn btn-success btn-large"
            :disabled="!responsavelFinanceiroSelecionado"
          >
            Acessar extrato
          </button>
        </template>
        <p v-else class="emptyMessage" role="status">
          Nenhum responsável financeiro foi encontrado nas matrículas deste aluno.
        </p>
      </form>
    </modal>
    <confirm 
      :backdrop="false"
      class="confirm"
      ref="confirm"
    ></confirm>
  </section>
</template>

<script>
import MatriculaService from '@/services/matricula.service.js'
import AgendaEduService from '@/services/agendaedu.service.js'
import AuthService from '@/services/auth.service.js'
import FinanceiroService from '@/services/financeiro.service.js'
import UserService from '@/services/user.service.js'
import HistoricoAtendimento from '@/components/atividades/utilities/atendimentos/Historico.vue'
import Modal from "@/components/utilities/Modal"
// import axios from 'axios'

export default {
  components: {
    HistoricoAtendimento, Modal
  },
  props: {
    aluno: {
      type: Object
    },
    fin: {
      type: [Number, String]
    },
    ped: {
      type: [Number, String]
    },
    responsaveisFinanceiros: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fin ( value ) {
      console.log("chegou aqui..... fin:", value)
      if ( value ) {
        this.getResp(value, 'fin')
      }
    },
    ped ( value ) {
      console.log("chegou aqui..... ped:", value)
      if ( value ) {
        this.getResp(value, 'ped')
      }
    }
  },
  data () {
    return {
      histType: {
        label: "Atendimentos",
        slug: "atendimentos",
        single: "Atendimento"
      },
      links: [
        { 
          label: 'Redefinir Senha do Email', 
          icon: ['fal','lock-keyhole-open'], 
          slug: 'redefinir-senha-aluno',
          type: 'action'
        },
        { 
          label: 'Relatório Pedagógico',
          icon: ['fal','book-open-reader'], 
          slug: 'pedagogico',
          type: 'painel'
        },
        // { 
        //   label: 'Frequências',
        //   icon: ['fal','calendar-circle-user'], 
        //   slug: 'frequencias',
        //   type: 'painel'
        // },
        // { 
        //   label: 'Avaliações', 
        //   icon: ['fal','file-check'], 
        //   slug: 'avaliacoes',
        //   type: 'painel'
        // },
        // { 
        //   label: 'Notificações Escolares', 
        //   icon: ['fal','file-circle-exclamation'], 
        //   slug: 'notificacoesescolares',
        //   type: 'painel'
        // },
        // { 
        //   label: 'Orientações de Estudo', 
        //   icon: ['fal','book-open-reader'], 
        //   slug: 'orientacoesestudo',
        //   type: 'painel' 
        // },
        { 
          label: 'Shop Decisão', 
          icon: ['fal','store'], 
          slug: 'shop',
          type: 'action'
        },
        {
          label: 'Extrato Financeiro', 
          icon: ['fal','file-invoice-dollar'], 
          slug: 'extrato',
          type: 'link'
        }
      ],
      alertas: [
        { 
          label: 'Negociações Ativas', 
          icon: ['fal','money-check-dollar-pen'], 
          slug: 'negociacoes',
          type: 'navigation', 
          value: 0
        },
        { 
          label: 'Bloqueios', 
          icon: ['fal','user-lock'], 
          slug: 'bloqueios',
          type: 'navigation', 
          value: 0 
        },
      ],
      respFin: null,
      modalContent: null,
      responsavelFinanceiroSelecionado: null,
      extratoHom: false,
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      waitUnidade: true,
      unidade: null,
      integraAgendaEdu: false
    }
  },
  mounted () {
    this.extratoHom = UserService.filterPermissions('extratoHom')
    this.integraAgendaEdu = UserService.filterPermissions('integraAgendaEdu')

    console.log("integraAgendaEdu:", this.integraAgendaEdu)
    if ( this.integraAgendaEdu ) {
      const intAeAluno = { 
        label: 'Integração Aluno - AgendaEdu', 
        icon: ['fa','circle'], 
        slug: 'integracao-ae-aluno',
        type: 'action',
        class: 'agenda-pendente'
      }
      const intAeRespFin = { 
        label: 'Integração Financeiro - AgendaEdu', 
        icon: ['fa','circle'], 
        slug: 'integracao-ae-respfin',
        type: 'action',
        class: 'agenda-pendente'
      }
      // const intAeRespPed = { 
      //   label: 'Integração Pedagógico - AgendaEdu', 
      //   icon: ['fa','circle'], 
      //   slug: 'integracao-ae-respped',
      //   type: 'action',
      //   class: 'agenda-pendente'
      // }

      this.links.splice(1, 0, intAeAluno)
      this.links.splice(2, 0, intAeRespFin)
      // this.links.splice(3, 0, intAeRespPed)
    }
    // console.log("this.aluno.......", this.aluno)
    if ( this.aluno.Aluno ) {
      this.getAlertas()
      this.getUnidade()
    }
    // if ( this.aluno.Aluno.responsavelFinanceiro ) this.getResp()

    if ( this.fin ) {
      this.getResp(this.fin,'fin')
    }
    if ( this.ped ) { 
      this.getResp(this.ped,'ped')
      console.log('achou o ped...', this.ped)
    }
  },
  methods: {
    getAlertas () {
      MatriculaService.getAlertasCentral( this.aluno.Aluno.idAluno ).then(
        response => {
          console.log("getAlertasCentral:", response.data)
          this.alertas[0].value = response.data.negociacoes
          this.alertas[1].value = response.data.bloqueios
          // this.alertas[2].value = response.data.debitos_matriculas
        },
        () => {

        }
      )
    },
    getDebitos (respFin) {
      FinanceiroService.getNegociacoesDebitos( respFin ).then(
        response => {
          console.log("getNegociacoesDebitos:", response.data)
          if ( response.data.length > 0 ) {
            const drop = response.data[0]
            const totalLoja = drop && drop.loja ? drop.loja?.matriculas.length : 0
            const totalMens = drop.perseus ? drop.perseus?.matriculas.length : 0
            const total = ( totalLoja ? totalLoja : 0 ) + ( totalMens ? totalMens : 0 )
            this.alertas[2].value = total
          }
        },
        () => {

        }
      )
    },
    getResp ( resp, type ) {
      const person = resp ?? ( type == 'fin' ? this.aluno.Aluno.responsavelFinanceiro.idPessoa : this.aluno.Aluno.responsavelPedagogico.idPessoa )

      console.log("type", type)
      console.log("person", person)

      MatriculaService.getPessoaByIdPessoaOuCpf(person,0).then(
        response => {
          console.log("getPessoaByIdPessoaOuCpf", response.data)
          if ( type == 'fin' ) {
            this.respFin = response.data.dados
            this.getDebitos(response.data.dados.Basicos.idPessoa)

            console.log("respFin depois do get:", this.respFin)
          }
          if ( type == 'ped' ) {
            this.respPed = response.data.dados
            console.log("respPed depois do get:", this.respPed)
          }
          
          
        },
        () => {

        }
      )
    },
    trackRoute ( item ) {
      if ( item.type == 'painel' ) {
        this.$emit("onAddPanel", item.slug)
      }

      if ( item.type == 'action' ) {
        this.trackAction(item.slug)
      }

      if ( item.type == 'link' ) {
        this.trackLink(item.slug)
      }

      if ( item.type == 'modal' ) {
        const options = {
          matricula: {
            idMatricula: this.aluno.Aluno.idMatricula
          },
          target: item.slug,
          size: 'full'
        }
        this.$emit("onModal", options)
      }

      if ( item.type == 'navigation' ) {
        if ( item.slug == 'pagamentos' && item.value > 0 ) {
          const params = '?idPessoaresp=' + this.respFin.Basicos.idPessoa + '&idMatricula=0&idAluno=' + this.aluno.Aluno.idAluno
          const path = 'renegociacoes/listaDebitos/' + params

          console.log("negocie path:", path)
          
          this.$router.push({ 
            name: 'LinkExterno', 
            params: { 
              id: 41,
              isMetabase: 0,
              isUrl: 0,
              token: process.env.VUE_APP_LARAVEL_API_LOGIN_TOKEN,
              email: this.currentUser.email
            },
            query: {
              numero_dashboard: 0,
              path: path,
            }
          })
        } else if ( item.slug != 'pagamentos' ) {
          this.$emit('onNavigation', item.slug)
        }
      }

    },
    trackAction ( action ) {
      if (  action == "integracao-ae-aluno" || action == 'integracao-ae-respfin' || action == 'integracao-ae-respped' ) {
        var target = action.split("-")
            target = target[target.length - 1]
        this.integrarAgendaEdu(target)
      }
      if ( action  == "redefinir-senha-aluno" ) {
        this.confirmResetGooglePassword()
      }
      if ( action  == "shop" ) {
        this.toggleShop()
      }
    },
    trackLink ( link ) {
      if ( link == 'shop-fin' || link == 'shop-ped'  ) {
        // console.log("this.respFin",  this.respFin)
        const user = link == 'shop-fin' ? this.respFin.Basicos.email : this.respPed.Basicos.email
        const url = "https://lojadecisao.com.br/loja?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjY4ODAsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6ODAwMC9hcGkvYXV0aC9sb2dpbiIsImlhdCI6MTU2MzQ3NzY4NywiZXhwIjoxNTYzNDgxMjg3LCJuYmYiOjE1NjM0Nzc2ODcsImp0aSI6ImRtRjZsYUMwWUswVTdzSVIifQ.ynkU2CQ2Kr3yt-cxA3o21y2wkg2HRj-zckdBYDy2MNE&email=" + user
        window.open(url)
        this.$refs.modal.close()
      } 
      if ( link == 'extrato' ) {
        if (this.responsaveisFinanceiros.length === 1) {
          this.responsavelFinanceiroSelecionado = this.responsaveisFinanceiros[0].value
          this.openExtrato()
          return
        }

        this.toggleExtrato()
      }
    },
    openExtrato () {
      if (!this.responsavelFinanceiroSelecionado) return

      const routeData = this.$router.resolve({
        name: 'Extrato Financeiro',
        params: { idPessoa: this.responsavelFinanceiroSelecionado }
      })

      window.open(routeData.href, '_blank', 'noopener,noreferrer')
      this.$refs.modal.close()
    },
    confirmResetGooglePassword () {
      this.$refs.confirm.run({
        message: "Tem certeza que deseja redefinir a senha deste aluno?",
        confirmButton: "Sim",
        denyButton: "Não",
        callback: this.resetGooglePassword,
      })
    },
    resetGooglePassword ( state ) {
      // console.log("aluno", this.aluno)
      const email = this.aluno.Aluno.emailAcademico
      if ( email ) {
        if ( state ) {
          window.spinner.emit('open')
          AuthService.resetGooglePassword( email ).then(
            response => {
              if ( response.data ) {
                // this.newPass = response.data.novaSenha
                this.$refs.confirm.run({
                  message: "Senha redefinida com sucesso!",
                  obs: "A nova senha foi encaminhada para o e-mail do responsável financeiro.<br><br><b>A nova senha é:</b> <br/><b style='font-size: 28px;' class='font-code'>" + response.data.novaSenha + "</b>",
                  confirmButton: "Copiar senha",
                  denyButton: "Fechar",
                  data: response.data.novaSenha,
                  size: 'mid',
                  callback: this.copy,
                  preventCloseOnTrue: true
                })
              } else {
                //
              }
              console.log("response:", response)
              window.spinner.emit('close')
            },
            error => {
              console.log("error:", error)
              window.spinner.emit('close')
            }
          )
        }
      } else {
        this.$refs.confirm.run({
          message: "Ops. Este aluno não tem email acadêmico cadastrado.",
          confirmButton: "Ok"
        })
      }
    },
    copy ( state, newPass ) {
      if ( state ) {
        navigator.clipboard.writeText(newPass)
        
        setTimeout(() => {
          window.toaster.emit('open', {style: "success", message: "Senha copiada para a área de transferência.", floater: true})
        },500)
      }
    },
    getUnidade () {
      UserService.getUnidades().then( response => {
        this.unidade = response.data.filter( a => a.idUnidade == this.aluno.Aluno.idUnidade)[0]
        this.waitUnidade = false
      })
    },
    integrarAgendaEdu (target) {
      console.log("target:", target)

      const ano = this.aluno.Aluno.dataInicio.split('-')[0]

      const updateClasse = (slug, novaClasse) => {
        const link = this.links.find(l => l.slug === `integracao-ae-${slug}`)
        if (link) link.class = novaClasse
      }

      const commonOptions = {
        siglaUnidade: this.unidade.sigla,
        periodoLetivo: ano
      }

      if (target === 'aluno') {
        const options = {
          ...commonOptions,
          nome: this.aluno.Basicos.nome
        }

        AgendaEduService.integraAluno(options).then(response => {
          window.spinner.emit('close')
          if (response.data.errors) {
            updateClasse('aluno', 'agenda-pendente-error')
          } else {
            updateClasse('aluno', 'agenda-pendente-sucess')
          }
        }).catch(() => {
          updateClasse('aluno', 'agenda-pendente-error')
          window.spinner.emit('close')
        })
      }

      if (target === 'respfin') {
        const options = {
          ...commonOptions,
          nome: this.respFin.Basicos.nome
        }

        AgendaEduService.integraRespFin(options).then(response => {
          window.spinner.emit('close')
          if (response.data.errors) {
            updateClasse('respfin', 'agenda-pendente-error')
          } else {
            updateClasse('respfin', 'agenda-pendente-sucess')
          }
        }).catch(() => {
          updateClasse('respfin', 'agenda-pendente-error')
          window.spinner.emit('close')
        })
      }

      if (target === 'respped') {
        AgendaEduService.integraRespPed(commonOptions).then(response => {
          window.spinner.emit('close')
          if (response.data.errors) {
            updateClasse('respped', 'agenda-pendente-error')
          } else {
            updateClasse('respped', 'agenda-pendente-sucess')
          }
        }).catch(() => {
          updateClasse('respped', 'agenda-pendente-error')
          window.spinner.emit('close')
        })
      }
    },
    toggleShop () {
      this.modalContent = 'shop'

      const options = {
        title: 'Acessar Shop',
        titleAlign: "center",
        message: "Com quem você quer acessar o Shop?", //não obrigatório
        size: "normal", //small, mid, normal, large, full
        backdrop: true,
        backdropColor: "transparent",  //se o backdrop for false, não precisa
        backdropClose: true,
        // onClose: this.closeEdit
      }

      console.log("toggleTransfer:", options)
      this.$refs.modal.open(options)
    },
    toggleExtrato () {
      this.modalContent = 'extrato'
      this.responsavelFinanceiroSelecionado = null

      const options = {
        title: 'Extrato Financeiro',
        titleAlign: 'left',
        message: 'Selecione o responsável financeiro para consultar o extrato.',
        size: 'normal',
        backdrop: true,
        backdropColor: 'transparent',
        backdropClose: true
      }

      this.$refs.modal.open(options)
    }
  }
}
</script>

<style lang="scss" scoped>
  .toolbar {
    padding: $hmg_mid;
    position: sticky; top: 60px;


    @keyframes pulse-aura {
        0% {
            box-shadow: 0 0 0 0 rgba($azul, 0.4);
        }
        70% {
            box-shadow: 0 0 0 5px rgba($azul, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba($azul, 0);
        }
    }

    @keyframes pulse-aura-sucess {
        0% {
            box-shadow: 0 0 0 0 rgba($verde, 0.4);
        }
        70% {
            box-shadow: 0 0 0 5px rgba($verde, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba($verde, 0);
        }
    }

    @keyframes pulse-aura-error {
        0% {
            box-shadow: 0 0 0 0 rgba($vermelho, 0.4);
        }
        70% {
            box-shadow: 0 0 0 5px rgba($vermelho, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba($vermelho, 0);
        }
    }

    .agenda-pendente{
      .icon{
        animation: pulse-aura 1.5s infinite !important;
        color: $azul !important;
        font-size: $font-size !important;
        border-radius: 50%;
      }
    }

    .agenda-pendente-sucess{
      .icon{
        animation: pulse-aura-sucess 1.5s infinite !important;
        color: $verde !important;
        font-size: $font-size !important;
        border-radius: 50%;
      }
    }

    .agenda-pendente-error{
      .icon{
        animation: pulse-aura-error 1.5s infinite !important;
        color: $vermelho !important;
        font-size: $font-size !important;
        border-radius: 50%;
      }
    }

    .links {
      margin-bottom: $mg;

      ul {
        padding: 0; margin: 0;

        li {
          list-style: none;
          margin: 0 0 $mg_mini 0; padding: 0;

          a {
            display: flex; align-items: center;
            justify-content: space-between;
            border-radius: $border-radius;
            border: $border-component;
            background-color: $color-secondary;
            height: 44px; padding: 0 $mg_mini 0 $hmg_small;
            @extend %transition_3o;
            position: relative;

            >div {
              display: flex; align-items: center;
              gap: $mg_mini;
              line-height: 1;
              position: relative;

              p {
                margin: 0; padding: 0;
              }
            }

            .icon {
              font-size: 20px
            }
            span:not(.negocie) {
              width: 25px; height: 25px;
              border-radius: $border-radius-small;
              border: $border-component;
              line-height: 25px; text-align: center;
              font-weight: bold;
              background-color: $color-bg
            }

            .negocie {
              display: inline-block;
              width: auto; white-space: nowrap;
              border-radius: 2em;
              padding: $hmg_mini $mg_mini;
              background-color: $color-primary;
              color: $color-secondary;
              text-align: center;
              position: absolute; right: 0; bottom: 0;
              transform: translateY(80%);

              &:before {
                content: '';
                display: block; width: 10px; height: 10px;
                border-radius: 2px; z-index: 0;
                position: absolute; top: 3px; left: 50%; right: 0;
                margin: auto;
                transform: rotate(45deg) translate(-50%, -50%);
                background-color: $color-primary;
              }
            }

            &:hover {
              box-shadow: 1px 3px 14px rgba(0,0,0,0.1)
            }
          }
        }
      }
    }
  }
  
  .modalWrap {
    display: flex; width: 100%;
    gap: $hmg_mid; align-items: center;
    justify-content: center;

    @media screen and (max-width: 640px ) {
      flex-direction: column;
    }
  }

  .extratoForm {
    display: flex;
    flex-direction: column;
    gap: $hmg_mid;

    .btn {
      align-self: flex-end;
      min-width: 160px;
    }

    .emptyMessage {
      margin: 0;
    }

    @media screen and (max-width: 640px) {
      .btn {
        align-self: stretch;
        width: 100%;
      }
    }
  }
</style>
